module.exports = __webpack_public_path__ + "img/bingtu.ee3155bc.svg";